import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints } from '../../utils/endpoints';
import { FinalizedPermissionsResponse } from '../models/responses/finalized-permissions.response';
import { PermissionContext, PermissionGroup, UserGroupResponse } from '../models/requests/finalized-permissions.request';
import { Observable } from 'rxjs';
import { PermissionDetailed } from '../models/responses/permissions.response';


@Injectable({
    providedIn: 'root',
})
export class PermissionsService {
    private http = inject(HttpClient);


    fetchPermissionsRequest(userId: string, permissionContexts: PermissionContext[] = []): Observable<FinalizedPermissionsResponse> {
        return this.http.post<FinalizedPermissionsResponse>(
            endpoints.permissions.children.getFinalizedPermissions(userId),
            { permissionContexts: permissionContexts }
        );
    }
    fetchPermissionRequest(userId: string, permissionContexts: PermissionContext[] = []): Observable<FinalizedPermissionsResponse> {
        return this.http.post<FinalizedPermissionsResponse>(
            endpoints.permissions.children.getFinalPermissions(),
            { userIds: [userId],
                inputContext: { permissionContexts: permissionContexts } }
        );
    }

    fetchDetailedPermissionsRequest(): Observable<PermissionDetailed[]> {
        return this.http.get<PermissionDetailed[]>(
            endpoints.permissions.children.getDetailedPermissions()
        );
    }

    fetchGroup(enitityName: string, entityType: string, entityId: string): Observable<PermissionGroup> {
        return this.http.post<PermissionGroup>(
            endpoints.permissions.children.getGroupByName(enitityName),
            {
                contextEntityType: entityType,
                contextEntityId: entityId,
                name: enitityName
            }
        );
    }

    getUsersByGroup(groupId: string): Observable<UserGroupResponse> {
        return this.http.get<UserGroupResponse>(
            endpoints.permissions.children.getUsersByGroup(groupId),
        );
    }
}

